import ProductGrid from '@nespresso/catalog-components-react/containers/ProductGrid';
import type { ComponentChildren } from 'preact';
import cn from 'classnames';
import styles from './CardBase.module.scss';
import ProductImageSection from '../sections/ProductImageSection/ProductImageSection.tsx';
import ProductNameSection from '../sections/ProductNameSection/ProductNameSection.tsx';
import ProductPurchaseSection from '../sections/ProductPurchaseSection/ProductPurchaseSection.tsx';
import ProductSpecificationSection from '../sections/ProductSpecificationSection/ProductSpecificationSection.tsx';

export type CardBaseProps = {
  children: ComponentChildren;
  className?: string;
  onClick?: (event: MouseEvent) => void;
  extensions?: ComponentChildren;
  productType?: string;
  longSku?: string;
  shortSku?: string;
};

export default function CardBase({
  children,
  onClick,
  className,
  extensions,
  productType,
  longSku,
  shortSku
}: CardBaseProps) {
  const isInteractive = onClick !== undefined;

  return (
    <ProductGrid.GridItem
      className={cn(
        styles.card,
        { [styles.interactive]: isInteractive },
        className
      )}
      onClick={onClick}
      data-product-long-sku={longSku}
      data-product-short-sku={shortSku}
      {...(productType ? { 'data-product-type': productType } : {})}
    >
      <>
        {children}
        {extensions}
      </>
    </ProductGrid.GridItem>
  );
}

CardBase.Skeleton = function Skeleton() {
  return (
    <ProductGrid.GridItem className={styles.skeleton}>
      <ProductGrid.GridItemHeader>
        <ProductNameSection.Skeleton />
      </ProductGrid.GridItemHeader>
      <ProductGrid.GridItemImageSection>
        <ProductImageSection.Skeleton />
      </ProductGrid.GridItemImageSection>
      <ProductGrid.GridItemContent>
        <ProductSpecificationSection.Skeleton />
      </ProductGrid.GridItemContent>
      <ProductGrid.GridItemFooter>
        <ProductPurchaseSection.Skeleton />
      </ProductGrid.GridItemFooter>
    </ProductGrid.GridItem>
  );
};
